const StatisticTypes = {
	GET_PERCENT_WORD_DONT_HAVE_DEFINITION:
		'GET_PERCENT_WORD_DONT_HAVE_DEFINITION',
}

export default StatisticTypes
